// src/admin/pages/KPI/components/kpi/GMVSection.js
import React from "react";
import { useMediaQuery } from "react-responsive";
import KPICard from "./KPICard";

/* ------------------------------------------------------------------
   Helper per formattare valori monetari ed evitare NaN / undefined
------------------------------------------------------------------ */
const fmt = (v) =>
  typeof v === "number" && !Number.isNaN(v) ? `€ ${v.toFixed(2)}` : "€ 0.00";

/**
 * Sezione KPI “GMV”
 *
 * Props:
 *  - kpis         (object)  → dati restituiti dall’endpoint KPI
 *  - onCardClick? (func)    → handler (cardKey) ⇒ mostra trend
 */
export default function GMVSection({ kpis, onCardClick }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (!kpis) return null;

  return (
    <div style={grid(isMobile)}>
      {/* ORDINI & RICAVI --------------------------------------------------- */}
      <KPICard
        title="Ordini Consegnati"
        value={kpis.delivered_orders_count}
        description="N. ordini delivered/finalized"
        onClick={() => onCardClick?.("delivered_orders_count")}
      />
      <KPICard
        title="Fatturato Totale"
        value={fmt(kpis.total_revenue)}
        description="Somma vendite"
        onClick={() => onCardClick?.("total_revenue")}
      />
      <KPICard
        title="Carrello Medio"
        value={fmt(kpis.average_cart)}
        description="Ricavo medio a sessione"
        onClick={() => onCardClick?.("average_cart")}
      />
      <KPICard
        title="Sessioni"
        value={kpis.total_sessions_count}
        description="Tavoli occupati"
        onClick={() => onCardClick?.("total_sessions_count")}
      />

      {/* COSTI ------------------------------------------------------------- */}
      <KPICard
        title="Costo Ingredienti"
        value={fmt(kpis.total_ingredient_cost)}
        description="Ingredienti usati negli ordini"
        onClick={() => onCardClick?.("total_ingredient_cost")}
      />
      <KPICard
        title="Costi Extra"
        value={fmt(kpis.total_overhead_cost)}
        description="Overhead (affitti, utenze…)"
        onClick={() => onCardClick?.("total_overhead_cost")}
      />
    </div>
  );
}

/* ------------------------------------------------------------------
   Stile griglia responsive
------------------------------------------------------------------ */
const grid = (isMobile) => ({
  display: "grid",
  gap: "1rem",
  marginTop: "1rem",
  gridTemplateColumns: isMobile
    ? "repeat(auto-fill, minmax(160px, 1fr))"
    : "repeat(auto-fill, minmax(200px, 1fr))",
});
